import { render, staticRenderFns } from "./MasterDataShiftsPage.vue?vue&type=template&id=6b83f6b7&scoped=true&lang=pug&"
import script from "./MasterDataShiftsPage.vue?vue&type=script&lang=ts&"
export * from "./MasterDataShiftsPage.vue?vue&type=script&lang=ts&"
import style0 from "./MasterDataShiftsPage.vue?vue&type=style&index=0&id=6b83f6b7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b83f6b7",
  null
  
)

export default component.exports